import { Loadable } from '../Loadable';

export const AsyncVenueList = Loadable(() => import('./VenueList'));
export const AsyncVenueHome = Loadable(() => import('./VenueHome'));
export const AsyncVenueHomeCustom = Loadable(() => import('./VenueHomeCustom'));
export const AsyncWelcomeScreen = Loadable(() => import('./WelcomeScreen'));
